/* eslint-disable camelcase */
import React from 'react';
import { useSelector } from 'react-redux';

const TrainingMode = () => {
  const { TRAININGMODE, INVALIDRECEIPT } = useSelector((state) => state);

  return (
    <>
      <p>{TRAININGMODE}</p>
      <p>{INVALIDRECEIPT}</p>
      <br />
    </>
  );
};

export default TrainingMode;
